import _ from "lodash";
import { interpolateRgb } from "d3-interpolate";
import { consolidateStreamedStyles } from "styled-components";

export const getStationColor = (stationId) => {
  if (_.includes(stationId, "BTS.E") || _.includes(stationId, "BTS.N"))
    return "#77cc00";
  if (_.includes(stationId, "BTS.W") || _.includes(stationId, "BTS.S"))
    return "#246b5b";
  if (_.includes(stationId, "MRT.")) return "#1964b7";
  return "#000";
};

export const getMinMaxColorByScoreType = (scoreType) => {
  switch (scoreType) {
    case "capitalGain":
    case "rentalYield":
      return { min: "#9bedff", max: "#2a0e56" };
    default:
      return { min: "#4caf50", max: "#b23c17" };
  }
};

export const getColorByScoreType = (value, min, max, scoreType) => {
  switch (scoreType) {
    case "facilityScore":
      return getColor(value, min, max, "#b23c17", "#4caf50");
    case "capitalGain":
    case "rentalYield":
      return getColor(value, min, max, "#9bedff", "#2a0e56");
    default:
      return getColor(value, min, max, "#4caf50", "#b23c17");
  }
};

export const getColor = (value, min, max, colorStart, colorStop) => {
  const interpolator = interpolateRgb(colorStart, colorStop);
  const _value = (value - min) / (max - min);
  return interpolator(_value);
};

export const getHslColorByWeight = ({ weight, maxH, h2, h1, s, l }) => {
  const diffByWeight = Math.abs(h2 - h1) * weight;
  const h = maxH - diffByWeight;
  return [h, s, l];
};

export const hslToHex = ([h, s, l]) => {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(_.get(result, "1"), 16),
        g: parseInt(_.get(result, "2"), 16),
        b: parseInt(_.get(result, "3"), 16),
      }
    : null;
};

export const rgbToHex = ([r, g, b]) => {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};



// WEBPACK FOOTER //
// ./src/utils/color-utils.js